import { Box } from '@mui/material';
import { MdOutlineHelpOutline } from 'react-icons/md';
import { Item, WsColors } from 'wisestep-base';

import SettingsIndex from '../../../../../components/SettingsIndex';

const FAQIndex = () => (
  <Box p={3}>
    <Item sx={{ backgroundColor: WsColors.White }}>
      <SettingsIndex
        options={[
          {
            label: 'FAQs',
            icon: <MdOutlineHelpOutline size={25} />,
            url: '/recruiter/faq',
            subOptions: [
              {
                label: 'Jobs',
                url: '/recruiter/faq',
              },
              {
                label: 'Candidates',
                url: '/recruiter/faq-candidates',
              },
              {
                label: 'Data Privacy',
                url: '/recruiter/faq-data-privacy',
              },
              {
                label: 'Browser Extension',
                url: '/recruiter/faq-browser-extension',
              },
              {
                label: 'Team Owners',
                url: '/recruiter/faq-team-owners',
              },
            ],
          },
        ]}
      />
    </Item>
  </Box>
);

export default FAQIndex;
